module.exports = __webpack_public_path__ + "static/img/home-item6.f1934db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-item6.png
// module id = l077
// module chunks = 21